import React from 'react';
import base from '../main2.jpg';
import { Link } from 'react-router-dom';
import logo from '../logo.png';
const Register = (props) => {
    return <div className="modal fade " id="register" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg" style={{ maxWidth: 1444, marginTop: 0, marginBottom: 0, height: "calc(100% - 20px)" }} role="document">
            <div className="modal-content" style={{ height: 'calc(100% - 10px)' }}>
                <button type="button" className="close btn m-3 text-right" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true" className="text-info">  <i className="far fa-window-close"></i></span>
                </button>
                <div className="modal-body p-0 m-0" style={{ height: "100%", top: 7 }}>

                    <div className="row" style={{ height: "100%" }}>
                        <div className="col-md-4 d-none d-md-block" style={{ height: "100%" }}>
                            <div style={{ height: "100%" }}>
                                <div className="imagelogin" style={{ backgroundImage: `url(${base})` }}></div>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-8">

                            <div className="p-4 row" style={{ backgroundColor: '#12242e' }}>

                                <div className="col-sm-3 d-none d-lg-block"></div>
                                <div className="col-sm-12 col-lg-6">
                                    <div className="sidebar-header d-flex justify-content-center pb-3">
                                        <Link to="/" style={{ fontSize: 30, textAlign: 'center' }}>
                                            <img className="img-logo" alt="" src={logo} width='100px' />
                                            GRIFFON.<span style={{ color: "white" }}>BET</span></Link>
                                    </div>
                                    <h3>{props.language().register}</h3>
                                    <form style={{textAlign:'center'}}>
                                        <div className="form-group row">

                                            <div className="col-sm-12">
                                                <input type="text" className="form-control" id="usernameRegister" placeholder={props.language().user} />
                                            </div>
                                        </div>
                                        <div className="form-group row">

                                            <div className="col-sm-12">
                                                <input type="password" className="form-control" id="passRegister" placeholder={props.language().pass} />


                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <div className="col-sm-12">
                                                <input type="email" className="form-control" id="emailRegister" placeholder={props.language().email} />
                                            </div>
                                        </div>
                                        <div className="form-group row p-0 m-0">
                                            <small id="birthday" className="form-text text-muted float-left">{props.language().birthday}</small>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-sm-4">
                                                <input type="number" className="form-control" id="day" placeholder="DD" />
                                            </div>
                                            <div className="col-sm-4">
                                                <input type="number" className="form-control" id="month" placeholder="MM" />
                                            </div>
                                            <div className="col-sm-4">
                                                <input type="number" className="form-control" id="year" placeholder="YYYY" />
                                            </div>
                                        </div>
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend col-xs-1">
                                                <div className="input-group-text">
                                                    <input type="checkbox" aria-label="Checkbox for following text input" />
                                                </div>
                                            </div>
                                            <small className="col-xs-11" style={{ backgroundColor: "#1a3442", lineHeight: "18px", paddingRight: 15, borderTopRightRadius: 5, borderBottomRightRadius: 5, border: '1px solid #156171', borderLeft: 'none' }}>
                                                {props.language().confirm}<br />
                                                <Link to=''> {props.language().terms}</Link>
                                            </small>
                                        </div>
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <div className="input-group-text">
                                                    <input type="checkbox" aria-label="Checkbox for following text input" />
                                                </div>
                                            </div>
                                            <small style={{ backgroundColor: "#1a3442", paddingRight: 15, borderTopRightRadius: 5, borderBottomRightRadius: 5, border: '1px solid #156171', borderLeft: 'none' }}>
                                                {props.language().marketing} </small>
                                        </div>


                                        <div className="form-group row">
                                            <div className="col-sm-12">
                                                <button type="submit" className="btn btn-success">  {props.language().register}</button>
                                                {/* <button type="submit" className="btn btn-outline-success  float-right">Registrarse</button> */}
                                                {/* </div> */}
                                                {/* <div className="col-sm-12"> */}
                                                <small id="emailHelp" className="form-text text-muted float-right">
                                                    {props.language().alreadyRegister}
                                                    <Link to='' data-toggle="modal" data-dismiss="modal" data-target="#login"> {props.language().login}</Link>
                                                </small>
                                            </div>
                                        </div>
                                        <div id="lds" className="lds-facebook "><div></div><div></div><div></div></div>

                                    </form>
                                </div>
                                <div className="col-sm-3 d-none d-lg-block"></div>
                            </div>

                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>

}

export default Register;


// WEBPACK FOOTER //
// ./src/components/Register.js